<mat-card style="width: min-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Service Details</mat-card-title>
                <mat-card-subtitle>
                    View service catalogue from CodeSystem and see what is configured.
                </mat-card-subtitle>
            </div>

            <div class="right gap-10 g-just-flex" style="flex: 1 1 auto; justify-content: flex-end;">
                <a mat-flat-button [routerLink]="['/app/add-service-details']">
                    <mat-icon>add</mat-icon>
                    Add Service Details
                </a>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>

        <div class="my-12 g-just-flex flex-between align-items-center flex-wrap gap-20"
        style=" width: 100%; ">
        
            <app-custom-tabs [tabs]="tabs" [activeTabId]="activeTabId" (tabClicked)="onTabClicked($event)" style="flex: 1; 
            margin-right:50px;
            " />
             
            <div class="search-box" style="display: flex; align-items: center; background-color: var(--mat-sys-surface); border: 1px solid var(--mat-sys-outline, #ccc); border-radius: 4px; padding: 0 8px;">
                <mat-icon style="color: var(--mat-sys-on-surface-variant, #666); margin-right: 4px;">search</mat-icon>
                <input type="text" placeholder="Search services..." 
                       style="padding: 10px 4px; border: none; outline: none; background: transparent; min-width: 250px; font-size: 14px; color: var(--mat-sys-on-surface);"
                       [value]="searchQuery"
                       (input)="onSearchChange($event)">
            </div>
        </div>

        <div class="table-or-empty" style="background-color: var(--mat-sys-surface)">
            @if (rows.length) {
            <table style="min-width: 720px; width: unset" mat-table [dataSource]="rows"
                class="mat-elevation-z8 demo-table">
                <ng-container matColumnDef="service">
                    <th mat-header-cell *matHeaderCellDef>Service</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="top pt-8 restrict-length">
                            <span class="restrict-length">{{ row.display }}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let row">{{ row.code }}</td>
                </ng-container>

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>Category</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="subtitle-text-color-2">{{ row.categoryDisplay || 'N/A' }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef>Active</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="subtitle-text-color-2">{{ row.active ? 'Yes' : 'No' }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="items">
                    <th mat-header-cell *matHeaderCellDef>Items Required</th>
                    <td mat-cell *matCellDef="let row">{{ row.itemsRequiredCount || 0 }}</td>
                </ng-container>

                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Selling Price</th>
                    <td mat-cell *matCellDef="let row">
                        <strong>{{ row.totalPriceDisplay || 'N/A' }}</strong>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let row">
                        @if(canEditRow(row)) {
                        <a mat-stroked-button [routerLink]="['/app/add-service-details']"
                            [queryParams]="{ code: row.code }">
                            <mat-icon>edit</mat-icon>
                            Edit
                        </a>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            } @else {
            <div class="g-just-flex flex-column align-items-center py-40" style="text-align: center;">
                @if (activeTabId === 'configured') {
                <app-empty-state [icon]="'work'" [title]="'No Configured Services'"
                    [subtitle]="'No services currently have ActivityDefinition (items usage computation).'">
                </app-empty-state>
                } @else {
                <app-empty-state [icon]="'work'" [title]="'No Unconfigured Services'"
                    [subtitle]="'All services have ActivityDefinition (items usage computation).'">
                </app-empty-state>
                }
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>